import { useRouter } from 'expo-router';
import BadgeAssigneeDelete from '@/screens/BadgeAssigneeDelete';

export default function PrivateBadgeAssigneeAssigneeIdDeleteRoute() {
  const { back } = useRouter();

  return <BadgeAssigneeDelete onDeleted={back} />;
}
